import React from "react";


export const SparkleStarsSvg = () => (
    <svg
        width="20"
        height="30"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M10 2L11 5L14 6L11 7L10 10L9 7L6 6L9 5L10 2Z"
            fill="#1DA1F2"
        />
        <path
            d="M16 8L16.6 9.8L18.5 10.4L16.6 11L16 13L15.4 11L13.5 10.4L15.4 9.8L16 8Z"
            fill="#1DA1F2"
        />
        <path
            d="M5 9L5.4 10.2L6.8 10.6L5.4 11L5 12.5L4.6 11L3.2 10.6L4.6 10.2L5 9Z"
            fill="#1DA1F2"
        />
    </svg>
);

